/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import React, { useContext, useState } from 'react';

import { SideItem, SideItemImage, SideText } from './styled';

export default function VideoSide({
  item,
}: {
  item: { cover?: { uri: string }; title?: string; description?: string };
}) {
  const [focus, setFocus] = useState(false);

  return (
    <>
      <SideItem active={focus} onFocus={() => setFocus(true)} onBlur={() => setFocus(false)}>
        <>
          <SideItemImage active={focus} source={item.cover} />
          <SideText>{item.title}</SideText>
        </>
      </SideItem>
    </>
  );
}
